

















import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { IcoachSkillShortInfo } from '@/interfaces'

@Component({
  name: 'RaterRateeSkillCard'
})
export default class RaterRateeSkillCard extends Vue {
  @Prop({ required: true })
  skill!: IcoachSkillShortInfo

  @Emit()
  rate () {
    return this.skill
  }
}
